import { render, staticRenderFns } from "./dangerousGoodPackageDialog.vue?vue&type=template&id=5a3b86dc&"
import script from "./dangerousGoodPackageDialog.vue?vue&type=script&lang=js&"
export * from "./dangerousGoodPackageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a3b86dc')) {
      api.createRecord('5a3b86dc', component.options)
    } else {
      api.reload('5a3b86dc', component.options)
    }
    module.hot.accept("./dangerousGoodPackageDialog.vue?vue&type=template&id=5a3b86dc&", function () {
      api.rerender('5a3b86dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/dangerousGoodPackageDialog.vue"
export default component.exports